module.exports = __webpack_public_path__ + "1993bfef3e8db21c57f9aa451702b9dc.svg";